import RiskAssessmentStep from './RiskAssessmentStep';

export default RiskAssessmentStep;
